(() => {
  const root = document.querySelector('.ea26');
  const stateKey = Symbol.for('etool.accessory-guide-navigation');
  if (!root || root[stateKey]) return;
  root[stateKey] = true;

  let frame = null;
  let version = 0;

  function targetFor(hash) {
    if (!hash || hash === '#') return null;
    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch {
      return null;
    }
    const target = document.getElementById(id);
    return target && root.contains(target) ? target : null;
  }

  function reveal(hash, focus) {
    const currentVersion = ++version;
    if (frame !== null) {
      cancelAnimationFrame(frame);
      frame = null;
    }
    const target = targetFor(hash);
    if (!target) return;
    for (let parent = target; parent && parent !== root; parent = parent.parentElement) {
      if (parent.tagName === 'DETAILS') parent.open = true;
    }
    frame = requestAnimationFrame(() => {
      if (currentVersion !== version || !target.isConnected || targetFor(location.hash) !== target) return;
      frame = null;
      target.scrollIntoView({ block: 'start', behavior: 'auto' });
      if (focus) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    });
  }

  root.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href^="#"]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const hash = link.getAttribute('href');
    if (!targetFor(hash)) return;
    event.preventDefault();
    if (location.hash !== hash) history.pushState(null, '', hash);
    reveal(hash, true);
  });

  window.addEventListener('hashchange', () => reveal(location.hash, true));
  window.addEventListener('popstate', () => reveal(location.hash, false));
  if (location.hash) reveal(location.hash, false);
})();
